function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M555.68,66.8l3.68,74.29c60.23,66.53,84,160.76,54,249.32-44.75,132.2-192.32,201.7-329.61,155.22S71.47,354.31,116.23,222.11C146.31,133.26,222.84,72.73,311.47,56.7L359.36.12C210-3.92,69,88.81,18.56,237.79c-62,183,36.19,381.67,219.24,443.64s381.67-36.19,443.64-219.24C731.79,313.45,676.41,154.43,555.68,66.8Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M293.65,226.35s-29.88,37.28-23.28,83.17,40.72,68.25,67.19,77.22,67.16,11.92,100.28-20.53,32-80.21,32-80.21l-2.53-103.85-2-59.76-1.37-51.77s.29-25-.59-30.83a9.54,9.54,0,0,0-1-3.12c-.06-.12-.11-.25-.17-.37l-.2-.32a8.05,8.05,0,0,0-10.25-3.38l-.12,0L451,33a9.57,9.57,0,0,0-2.55,1.77c-4.26,4.13-19.19,24.13-19.19,24.13L396.66,99.15l-37.91,46.24Z"
});

var SvgMattermost = function SvgMattermost(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 700 700",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMattermost, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mattermost.9a2b270a.svg";
export { ForwardRef as ReactComponent };